module.exports = __webpack_public_path__ + "static/media/calender.c3296c0a.svg";